import { makeAutoObservable } from "mobx";

class StoreMassAddition {
    loadedFiles: number = 0;
    countFilesForLoading:number = 0;
    status:string = 'stop'

    constructor() {
        makeAutoObservable(this);
    }

    startLoad(countFiles:number) {
        this.status = 'start'
        this.loadedFiles = 0;
        this.countFilesForLoading = countFiles;
    }

    loadFile() {
        this.loadedFiles++;

        if(this.loadedFiles <= this.countFilesForLoading) {
            this.status = 'stop';
        }
    }

    get progressPercent() {
        if (this.countFilesForLoading === 0) return 0;
        return Math.round((this.loadedFiles / this.countFilesForLoading) * 100);
    }

    clear() {
        this.loadedFiles = 0;
        this.countFilesForLoading = 0;
        this.status = 'stop';
    }
}

export const storeMassAddition = new StoreMassAddition();